// extracted by mini-css-extract-plugin
module.exports = {"defaultBtn":"DefaultBtn_defaultBtn__DALY8"};